import { Address } from '@mwe/models';
import { MeterpointStatus } from './meterpoint-status.model';
import { Ummeldung } from '../../generated/model/ummeldung.model';
import StatusEnum = Ummeldung.StatusEnum;

export interface IMeterPoint {
  zaehlpunktId: string;
  zaehlpunktnummer: string;
  status: MeterpointStatus;
  zaehlerNr: string;
  geschaeftspartnerId: string;
  geschaeftspartnerNr: string;
  sparte: string;
  adresse: Address;
  referenzname: string;

  verbrauchspreis?: string;
  vertragsbeginn?: string;
  vertragsbindung?: string;
  vertragsende?: string;
  vertragskontonummer?: string;
  vertragsnummer?: string;

  iban?: string;
  bezahlart?: string;
  grundpreis?: string;
  rechnungsAdresse?: Address;
  rechnungsempfaengerName?: string;
  rechnungsversandArt?: string;
  rechnungsempfaengerEmail?: string;

  tarifName?: string;
  tarifKey?: string;
  unternehmenId?: string;

  legacyUmmeldungStatus: LegacyUmmeldungStatus;

  editableUmmeldungId?: string;
  ummeldungStatus?: StatusEnum;
  ummeldungCreatedAt?: string;
  ummeldungLetzterBearbeiterId?: string;
  ummeldungLetzterBearbeiterFirstName?: string;
  ummeldungLetzterBearbeiterLastName?: string;
}

export enum LegacyUmmeldungStatus {
  WARTEN_AUF_UNTERSCHRIFT = 'WARTEN_AUF_UNTERSCHRIFT',
}

export class MeterPoint implements IMeterPoint {
  id: string;
  zaehlpunktId: string;
  zaehlpunktnummer: string;
  status: MeterpointStatus;
  zaehlerNr: string;
  geschaeftspartnerId: string;
  geschaeftspartnerNr: string;
  sparte: string;
  adresse: Address;
  referenzname: string;

  verbrauchspreis?: string;
  vertragsbeginn?: string;
  vertragsbindung?: string;
  vertragsende?: string;
  vertragskontonummer?: string;
  vertragsnummer: string;

  iban?: string;
  bezahlart?: string;
  grundpreis?: string;
  rechnungsAdresse: Address;
  rechnungsempfaengerName?: string;
  rechnungsversandArt?: string;
  rechnungsempfaengerEmail?: string;

  tarifName?: string;
  tarifKey?: string;
  unternehmenId?: string;

  legacyUmmeldungStatus: LegacyUmmeldungStatus;
  editableUmmeldungId?: string;
  ummeldungStatus?: StatusEnum;
  ummeldungCreatedAt?: string;
  ummeldungLetzterBearbeiterId?: string;
  ummeldungLetzterBearbeiterFirstName?: string;
  ummeldungLetzterBearbeiterLastName?: string;

  constructor(meterPoint: IMeterPoint) {
    this.id = meterPoint.zaehlpunktId;
    this.zaehlpunktId = meterPoint.zaehlpunktId;
    this.zaehlpunktnummer = meterPoint.zaehlpunktnummer;
    this.status = meterPoint.status;
    this.legacyUmmeldungStatus = meterPoint.legacyUmmeldungStatus;
    this.zaehlerNr = meterPoint.zaehlerNr;
    this.geschaeftspartnerId = meterPoint.geschaeftspartnerId;
    this.geschaeftspartnerNr = meterPoint.geschaeftspartnerNr;
    this.sparte = meterPoint.sparte;
    this.adresse = meterPoint.adresse;
    this.referenzname = meterPoint.referenzname;

    this.verbrauchspreis = meterPoint.verbrauchspreis;
    this.vertragsbeginn = meterPoint.vertragsbeginn;
    this.vertragsbindung = meterPoint.vertragsbindung;
    this.vertragsende = meterPoint.vertragsende;
    this.vertragskontonummer = meterPoint.vertragskontonummer;
    this.vertragsnummer = meterPoint.vertragsnummer;
    this.iban = meterPoint.iban;
    this.bezahlart = meterPoint.bezahlart;
    this.grundpreis = meterPoint.grundpreis;
    this.rechnungsAdresse = meterPoint.rechnungsAdresse;
    this.rechnungsempfaengerName = meterPoint.rechnungsempfaengerName;
    this.rechnungsversandArt = meterPoint.rechnungsversandArt;
    this.rechnungsempfaengerEmail = meterPoint.rechnungsempfaengerEmail;
    this.tarifName = meterPoint.tarifName;
    this.tarifKey = meterPoint.tarifKey;
    this.unternehmenId = meterPoint.unternehmenId;

    this.editableUmmeldungId = meterPoint.editableUmmeldungId;
    this.legacyUmmeldungStatus = meterPoint.legacyUmmeldungStatus;
    this.ummeldungCreatedAt = meterPoint.ummeldungCreatedAt;
    this.ummeldungLetzterBearbeiterId = meterPoint.ummeldungLetzterBearbeiterId;
    this.ummeldungLetzterBearbeiterFirstName = meterPoint.ummeldungLetzterBearbeiterFirstName;
    this.ummeldungLetzterBearbeiterLastName = meterPoint.ummeldungLetzterBearbeiterLastName;
  }

  isUmmeldungInProgress(): boolean {
    return this.legacyUmmeldungStatus === LegacyUmmeldungStatus.WARTEN_AUF_UNTERSCHRIFT;
  }
}
